import { Component, ElementRef, Inject, Input, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LOCAL_STORAGE } from '@ng-toolkit/universal';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LoginService } from 'src/providers/login.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { CourseCouponDialog } from '../home-new/home-new.component';
import { MatDialog } from '@angular/material/dialog';
import { LoginModal } from '../header/header.component';
import { DOCUMENT } from '@angular/common';
import { HomeJSONIDService} from 'src/providers/home-schema'
import * as Aos from 'aos';
import { CAT2025JSONIDService } from 'src/providers/cat-2025.service';
import { HomeService } from 'src/providers/home.service';
import { isPlatformBrowser } from '@angular/common';


declare var $: any;

@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss']
})
export class MainPageComponent implements OnInit {


  activeCourseTab: any;
  selectedCourses: any[] = [];
  customCourseObj: any;
  yearFilter1: any = '2024';
  totalActualPrice: number = 0;
  totalOfferPrice: number = 0;
  cartArray: any[] = [];
  showContent:boolean = false;
  showContent1:boolean = false;
  showContent2:boolean = false;
  showContent3:boolean = false;

  userDetailsForm!: FormGroup;

  stepVal:any = 1;

    @Input('hideButton') hideButton:any = false;

    displayModule:boolean = false;

  constructor( public coursesService: CAT2025JSONIDService,
    public elementRef: ElementRef, public formBuilder: FormBuilder, @Inject(LOCAL_STORAGE) public sessionStorage: any,
    public loginService: LoginService, public dashboardService: HomeService, public deviceService: DeviceDetectorService,
    public router: Router, public matSnackBar: MatSnackBar, public sanitizer: DomSanitizer,
   @Inject(DOCUMENT) private dom: Document, public dialog: MatDialog,  @Inject(PLATFORM_ID) public platformId: Object,
   public homeSrvice: HomeJSONIDService, private titleService: Title, private metaService: Meta, public renderer2: Renderer2
  ) {

  }

  targetIIM:any;
  howPrepared:any;
  courseInterested:any;
  step1(val:any){
    this.targetIIM = val;
  }

  step2(val:any){
    this.seeYourself = val;
  }

  step3(val:any){
    this.howPrepared = val;
  }

  step4(val:any){
    this.courseInterested = val;
  }


  sendEventToGTM() {
    const s = this.renderer2.createElement('script');
    s.text =  `window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
    'event' : 'form_submission_success',
  })`;
    this.renderer2.appendChild(this.dom.body, s);
  }

  counsellingForm!: FormGroup;
  token: any;
  userData: any;

  slider1: any[] = [
    { img: 'https://media.iquanta.in/ui_images/rishi-mittal-new.webp', video: 'd8Datuvi4L4', percent: 'CAT 100%iler', name: 'Rishi Mittal' },
    { img: 'https://media.iquanta.in/ui_images/mayank-new.webp', video: 'v8O8ELvatPc', percent: 'CAT 99.76%iler', name: 'Mayank' },
    { img: 'https://media.iquanta.in/ui_images/rahul-agrawal-new.webp', video: 'GIrpNkOa8kQ', percent: 'CAT 99.92%iler', name: 'Rahul Agrawal' },
    { img: 'https://media.iquanta.in/ui_images/karal-maheshwari-new.webp', video: 'FjQPFPxlEjc', percent: 'CAT 99%iler', name: 'Karal Maheshwari' },
    { img: 'https://media.iquanta.in/ui_images/Kislay-Jha.webp', video: 'uUUseqANr7w', percent: 'CAT 99.96%iler', name: 'Kislay Jha' },
    { img: 'https://media.iquanta.in/ui_images/Karan-Dutta.webp', video: 'U7v8MmhfaOQ', percent: 'CAT 99.56%iler', name: 'Karan Dutta' },
    { img: 'https://media.iquanta.in/ui_images/new-home/topper2.jpg', video: '0udGFVgMd84', percent: 'CAT 99.5%iler', name: '' },
    { img: 'https://media.iquanta.in/ui_images/new-home/topper1.jpg', video: 'zHxUBf-yOhk', percent: 'CAT 99.97%iler', name: '' }
  ]

  membersList: any[] = [];
  examList: any[] = ['CAT', 'GDPI', 'GMAT', 'XAT', 'CMAT', 'MICAT']
  examList1: any[] = ['CUET UG', 'CUET PG', 'IPMAT', 'CLAT', 'IIT']
  callBackForm!: FormGroup;
  yearFilterMyOc: any = '2025';
  json1: any;
  json2: any;
  json3: any;
  json4: any;
  json5: any;

  leadId:any;
  seeYourself:any;
  formSubmitted:boolean = false;

  addInternalCRMLead1() {
      let medium: any;
      let source: any;
      let campaign: any;
      if (this.sessionStorage.getItem('utmLink')) {
        this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
          if (item.includes('utm_medium')) {
            medium = item.split('=')[1]
          }
          if (item.includes('utm_source')) {
            source = item.split('=')[1]
          }
          if (item.includes('utm_campaign')) {
            campaign = item.split('=')[1]
          }
        })
      }
      let reqObj = {
        "name": this.userDetailsForm.value.name,
        "firstName":  this.userDetailsForm.value.name,
        "phone":  this.userDetailsForm.value.mobile,
        "email": this.userDetailsForm.value.email,
        "countryCode": 91,
        "source": "Website",
        "medium": "Home Page",
        "campaign": 'Personalized Counselling',
        "orgId": "66dec57ce200bc89284602d6",
        "uid": '66dec57ce200bc89284602d6',
        "userId": this.userData ? this.userData.id : 9999,
        "registrationDate": this.userData ? new Date(this.userData.date_joined).valueOf() : new Date().valueOf(),
        "pageLocation": this.dom.URL,
        "registrationChannel": this.sessionStorage.getItem('utmLink') ? this.sessionStorage.getItem('utmLink') : this.dom.URL,
        "registrationDevice": this.deviceService.deviceType,
         courseInterestedIn: this.courseInterested ? this.courseInterested : '',
        "customFields": {
          "exam": 'CAT' ,
          "examCategory": 'MBA',
          "examTargetYear": this.userDetailsForm.value.currentstatus,
          "leadPriority": "Platinum",
          "q1":this.targetIIM ? this.targetIIM : '',
          "q2":this.seeYourself ? this.seeYourself : '',
          "q3":this.howPrepared ? this.howPrepared : ''
        },
        "ipAddress": this.sessionStorage.getItem('ipAddress'),
        dataSource: [
          {
            utmSource: source,
            utmMedium: medium,
            utmCampaign: campaign,
            utmAdContent: "",
            "source": "Website",
            "medium": "Home Page",
            "campaign": 'Personalized Counselling',
            adContent: "",
            "pageLocation": this.dom.URL,
            browser: this.deviceService.browser,
            browser_version: this.deviceService.browser_version,
            device: this.deviceService.device,
            deviceType: this.deviceService.deviceType,
            orientation: this.deviceService.orientation,
            os: this.deviceService.os,
            os_version: this.deviceService.os_version,
            platformId: this.deviceService['platformId'],
            ua: this.deviceService.ua,
            userAgent: this.deviceService.userAgent,
            "ipAddress": this.sessionStorage.getItem('ipAddress'),
            courseInterestedIn: this.courseInterested ? this.courseInterested : ''
          },
        ],
      }

      this.dashboardService.addCRMLead(reqObj).subscribe(res => {
        if (res.success) {
          this.selectedCategory = [];
          this.selectedExams = [];
          this.selectedExams1 = [];

        } else {
          this.selectedCategory = [];
          this.selectedExams = [];
          this.selectedExams1 = [];
        }
      }, err => {
        if (err.statusText == 'Unknown Error') {
          this.callBackLead(reqObj)
        }
      })
  }
  
  nextStep(){
    if(this.stepVal == 1){
      this.formSubmitted = false;

      if(this.userDetailsForm.valid){
        let reqObj = {
          "name":this.userDetailsForm.value.name,
          "email":this.userDetailsForm.value.email,
          "phone":this.userDetailsForm.value.mobile,
          "currentStatus":this.userDetailsForm.value.currentstatus,
      }
      this.coursesService.saveUserLEadForm(reqObj).subscribe(res=>{
        if(res.success){
          this.leadId = res.data.batch;
          this.stepVal++;
          this.sessionStorage.setItem('leadObj', JSON.stringify(res.data.batch))
          this.addInternalCRMLead1()
        }
      })
      }else{
      this.formSubmitted = true;
       
      }
    }else{
      if(this.stepVal == 2){
        if(this.targetIIM){
          let reqObj = {
            "targetIIM": this.targetIIM
        }
        this.coursesService.updateUserLeadForm(reqObj, this.leadId['_id']).subscribe(res=>{
          if(res.success){
            this.leadId['targetIIM'] = this.targetIIM;
            this.stepVal++;
            this.sessionStorage.setItem('leadObj', JSON.stringify(this.leadId))
          }
        })
        }
      }else if(this.stepVal == 3){
        if(this.seeYourself){
          let reqObj = {
            "seeYourself": this.seeYourself
        }
        this.coursesService.updateUserLeadForm(reqObj, this.leadId['_id']).subscribe(res=>{
          if(res.success){
            this.stepVal++;
            this.leadId['seeYourself'] = this.seeYourself;
            this.sessionStorage.setItem('leadObj', JSON.stringify(this.leadId))
          }
        })
        }
      }else if(this.stepVal == 4){
        if(this.howPrepared){
          let reqObj = {
            "howPrepared": this.howPrepared
        }
        this.coursesService.updateUserLeadForm(reqObj, this.leadId['_id']).subscribe(res=>{
          if(res.success){
            this.stepVal++;
            this.leadId['howPrepared'] = this.howPrepared;
            this.sessionStorage.setItem('leadObj', JSON.stringify(this.leadId))
          }
        })
        }
      }else if(this.stepVal == 5){
        if(this.courseInterested){
          let reqObj = {
            "step4": this.courseInterested
        }
        this.coursesService.updateUserLeadForm(reqObj, this.leadId['_id']).subscribe(res=>{
          if(res.success){
           this.leadSubmitted = true;
           this.leadId['step4'] = this.courseInterested;
           this.sessionStorage.setItem('leadObj', JSON.stringify(this.leadId))
           this.addInternalCRMLead1()
          }
        })
        }
      }
    // this.stepVal++;
    }
 }

 leadSubmitted:boolean = false;

 backStep(){
  this.stepVal--;
 }

  ngOnInit(): void {
    this.tableData = this.homeSrvice.courseComparison1;
    this.json1 = this.homeSrvice.HomeBusiness;
    this.json4 = this.homeSrvice.HomePerson;
    this.json2 = this.homeSrvice.HomeOrganization;
    this.json3 = this.homeSrvice.HomeFAQ;
  
    this.userDetailsForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')])],
      mobile: ['', Validators.compose([Validators.required, Validators.pattern('^[6-9]{1}[0-9]{9}$')])],
      currentstatus: ['', Validators.required],
    })
    this.sessionStorage.removeItem('pageUrl')
    Aos.init();
// Meta Data
    this.titleService.setTitle("iQuanta: CAT Online Coaching | Best CAT Coaching in India");
    this.metaService.updateTag( 
    { name: 'description', content: "CAT Online Coaching with iQuanta is recognized as the best CAT coaching online, renowned for its outstanding results. iQuanta CAT course features the best teaching methodologies for the CAT exam." });
    this.metaService.updateTag( 
    { name: 'keywords', content: 'CAT Online Coaching,cat coaching online,Best CAT Coaching in India,CAT Coaching in India,cat coaching,cat classes,cat course,cat online course,cat online classes,best CAT coaching online,best coaching for cat,best cat coaching,cat preparation,cat online preparation,best online coaching for cat,online coaching for cat,cat class,best cat classes' });
// Canonical Link
    const head = this.dom?.getElementsByTagName('head')[0];
    if (head) {
    var element: HTMLLinkElement = this.dom.createElement('link') as HTMLLinkElement
    element.setAttribute('rel', 'canonical')
    element.setAttribute('href', 'https://www.iquanta.in/')
    head.appendChild(element);
    }

// Facebook
    this.metaService.updateTag(
      { property: 'og:type', content: "website" })
    this.metaService.updateTag(
      { property: 'article:publisher', content: "https://facebook.com/iquanta.in" })
    this.metaService.updateTag(
      { property: 'og:title', content: "iQuanta: CAT Online Coaching | Best CAT Coaching in India" })
    this.metaService.updateTag(
      { property: 'og:url', content: 'https://www.iquanta.in/' })
    this.metaService.updateTag(
      { property: 'og:description', content: "CAT Online Coaching with iQuanta is recognized as the best CAT coaching online, renowned for its outstanding results. iQuanta CAT course features the best teaching methodologies for the CAT exam." });
    this.metaService.updateTag(
      { property: 'og:image:height', content: '720' })
    this.metaService.updateTag(
      { property: 'og:image:width', content: '1280' })
    this.metaService.updateTag(
      { property: 'og:image:type', content: 'image/webp' })
    this.metaService.updateTag(
      { property: 'og:image', content: 'https://media.iquanta.in/ui_images/new-home/cat-coaching.webp' })
// Article Publish Time
    this.metaService.updateTag(
      { property: 'article:published_time', content: '2022-01-23T10:48:33+00:00' })
    this.metaService.updateTag(
      { property: 'article:modified_time', content: '2025-05-23T11:24:42+00:00' })
// Twitter
    this.metaService.updateTag(
      { property: 'twitter:label2', content: "Est. reading time" })
    this.metaService.updateTag(
      { property: 'twitter:data2', content: "14 Minutes" })
    this.metaService.updateTag(
      { property: 'twitter:title', content: "iQuanta: CAT Online Coaching | Best CAT Coaching in India" })
    this.metaService.updateTag(
      { property: 'twitter:url', content: 'https://www.iquanta.in/' })
    this.metaService.updateTag(
      { property: 'twitter:description', content: "CAT Online Coaching with iQuanta is recognized as the best CAT coaching online, renowned for its outstanding results. iQuanta CAT course features the best teaching methodologies for the CAT exam." });
    this.metaService.updateTag(
      { property: 'twitter:image', content: 'https://media.iquanta.in/ui_images/new-home/cat-coaching.webp' })
    this.metaService.updateTag(
      { property: 'twitter:image:height', content: '720' })
    this.metaService.updateTag(
      { property: 'twitter:image:type', content: 'image/webp' })
    this.metaService.updateTag(
      { property: 'twitter:image:width', content: '1280' })

    this.counsellingForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')])],
      mobile: ['', Validators.compose([Validators.required, Validators.pattern('^[6-9]{1}[0-9]{9}$')])],
      course: ['', Validators.required],
      year: ['', Validators.required],
      time: ['', Validators.required]
    })
    this.token = this.sessionStorage.getItem('usertoken');
    if (this.token) {
      this.userData = JSON.parse(this.sessionStorage.getItem('userData'));
    }

    this.callBackForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      phone: ['', Validators.compose([Validators.required, Validators.pattern('^[6-9]{1}[0-9]{9}$')])],
      year: ['', Validators.required],
      course: ['']
    })
    this.getProfileData()
        this.getBannerVideos()
 
    this.membersList = this.homeSrvice.membersList;
    let leadData:any = this.sessionStorage.getItem('leadObj');
    if(leadData){
      let data:any = JSON.parse(leadData)
      if(data){
        if(data.step4){
          this.leadSubmitted = true;
        }
      }
    }

  }
 
  scrollSection(val:any){
    var elemnt: any = document.getElementById(val)
    elemnt.scrollIntoView({ behavior: "smooth" })
    this.router.navigate(['/' +'#' + val])
  }

  selectedImg:any;
  selectedIndex:any = 0;
  openGallery(ind:any){
    this.selectedIndex = ind;
    this.selectedImg = this.testimonialsList[ind];
    this.showContent3 = true;
    $('#GalleryModal1').modal('show')
  }

  prev(){
    if(this.selectedIndex > 0){
      this.selectedIndex--;
    this.selectedImg = this.testimonialsList[this.selectedIndex]
    }
  }

  next(){
    if(this.selectedIndex < this.testimonialsList.length - 1){
      this.selectedIndex++;
    this.selectedImg = this.testimonialsList[this.selectedIndex]
    }
  }

  goToLink1(course: any) {
    window.open(course.url, '_blank')
  }

  joinwhatsapp() {
    window.open('https://chat.whatsapp.com/E4ez36F44pQ1JicjuT2bJF', '_blank')
  }

  getProfileData() {
    this.loginService.profileData.subscribe(res => {
      this.token = this.sessionStorage.getItem('usertoken');
      if (this.sessionStorage.getItem('userData')) {
        this.userData = JSON.parse(this.sessionStorage.getItem('userData'));
      } else {
        this.userData = '';
        this.token = ''
      }
    })
  }



  getExamCategory() {
    let category: any;
    if (this.examList.includes(this.counsellingForm.value.course)) {
      category = 'MBA';
      this.selectedExams.push(this.counsellingForm.value.course)
    } else {
      category = 'After 12th';
      this.selectedExams1.push(this.counsellingForm.value.course)
    }
    return category;
  }
  selectedCategory: any[] = []
  selectedExams: any[] = []
  selectedExams1: any[] = []
  getExamCategory1() {
    this.callBackForm.value.course.forEach((course: any) => {
      if (this.examList.includes(course)) {
        if (!this.selectedCategory.includes('MBA')) {
          this.selectedCategory.push('MBA')
        }
        this.selectedExams.push(course)
      } else {
        if (!this.selectedCategory.includes('After 12th')) {
          this.selectedCategory.push('After 12th')
        }
        this.selectedExams1.push(course)
      }
    })
    this.addInternalCRMLead('Course Enquiry')
  }

  selectCat(val: any) {
    if (this.callBackForm.value.course.includes(val)) {
      this.callBackForm.value.course.splice(this.callBackForm.value.course.indexOf(val), 1)
    } else {
      let list: any[] = [];
      if (this.callBackForm.value.course) {
        list = this.callBackForm.value.course;

      }
      list.push(val)
      this.callBackForm.controls['course'].setValue(list)
    }
  }
  videoLink: any
  videoPlay(obj: any) {
    this.videoLink = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + obj.video + '?rel=0')
    $('#VideoPlayer').modal()
  }

  addInternalCRMLead(typ: any) {
    this.selectedCategory.forEach((cat: any) => {
      let medium: any;
      let source: any;
      let campaign: any;
      if (this.sessionStorage.getItem('utmLink')) {
        this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
          if (item.includes('utm_medium')) {
            medium = item.split('=')[1]
          }
          if (item.includes('utm_source')) {
            source = item.split('=')[1]
          }
          if (item.includes('utm_campaign')) {
            campaign = item.split('=')[1]
          }
        })
      }
      let reqObj = {
        "name": typ == 'Book 1 on 1 Counselling from MBA Experts' ? this.counsellingForm.value.name : this.callBackForm.value.name,
        "firstName": typ == 'Book 1 on 1 Counselling from MBA Experts' ? this.counsellingForm.value.name : this.callBackForm.value.name,
        "phone": typ == 'Book 1 on 1 Counselling from MBA Experts' ? this.counsellingForm.value.mobile : this.callBackForm.value.phone,
        "email": typ == 'Book 1 on 1 Counselling from MBA Experts' ? this.counsellingForm.value.email : this.callBackForm.value.email,
        "countryCode": 91,
        "source": "Website",
        "medium": "Free Counselling",
        "campaign": typ,
        "orgId": "66dec57ce200bc89284602d6",
        "uid": '66dec57ce200bc89284602d6',
        "userId": this.userData ? this.userData.id : 9999,
        "registrationDate": this.userData ? new Date(this.userData.date_joined).valueOf() : new Date().valueOf(),
        "pageLocation": this.dom.URL,
        "registrationChannel": this.sessionStorage.getItem('utmLink') ? this.sessionStorage.getItem('utmLink') : this.dom.URL,
        "registrationDevice": this.deviceService.deviceType,
        "customFields": {
          "exam": cat == 'MBA' ? this.selectedExams.join(',') : this.selectedExams1.join(','),
          "examCategory": cat,
          "examTargetYear": typ == 'Book 1 on 1 Counselling from MBA Experts' ? this.counsellingForm.value.year : 2025,
          "leadPriority": "Platinum",
        },
        "ipAddress": this.sessionStorage.getItem('ipAddress'),
        dataSource: [
          {
            utmSource: source,
            utmMedium: medium,
            utmCampaign: campaign,
            utmAdContent: "",
            "source": "Website",
            "medium": "Free Counselling",
            "campaign": typ,
            adContent: "",
            "pageLocation": this.dom.URL,
            browser: this.deviceService.browser,
            browser_version: this.deviceService.browser_version,
            device: this.deviceService.device,
            deviceType: this.deviceService.deviceType,
            orientation: this.deviceService.orientation,
            os: this.deviceService.os,
            os_version: this.deviceService.os_version,
            platformId: this.deviceService['platformId'],
            ua: this.deviceService.ua,
            userAgent: this.deviceService.userAgent,
            "ipAddress": this.sessionStorage.getItem('ipAddress'),
          },
        ],
      }

      this.dashboardService.addCRMLead(reqObj).subscribe(res => {
        if (res.success) {
          this.selectedCategory = [];
          this.selectedExams = [];
          this.selectedExams1 = [];
          this.counsellingForm.reset()
        } else {
          this.selectedCategory = [];
          this.selectedExams = [];
          this.selectedExams1 = [];
          this.counsellingForm.reset()

        }
      }, err => {
        if (err.statusText == 'Unknown Error') {
          this.callBackLead(reqObj)
        }
      })
    })
  }

  callBackLead(reqObj: any) {
    this.dashboardService.callbackLead(reqObj).subscribe(res => {
      this.selectedCategory = [];
      this.selectedExams = [];
      this.selectedExams1 = [];
    })
  }

  closeThanks(){
    $("#ThanksModal").modal('hide')
    location.reload()
  }

  submittedBtn: boolean = false;
  page_loaction: any;
  addNPF() {
    let medium: any;
    if (this.sessionStorage.getItem('utmLink')) {
      this.sessionStorage.getItem('utmLink').split('&').forEach((item: any) => {
        if (item.includes('utm_medium')) {
          medium = item.split('=')[1]
        }
      })
    }
    let reqObj = {
      "secret_key": "bd0f12c20c7949caa22d5635f44c1732",
      "college_id": "5802",
      "name": this.callBackForm.value.name,
      "field_last_name": '',
      "country_dial_code": "+91",
      "mobile": this.callBackForm.value.phone,
      "email": this.callBackForm.value.email,
      "field_gender": '',
      "field_exam_category": this.callBackForm.value.course,
      "field_exam": this.callBackForm.value.course,
      "field_course_year": this.callBackForm.value.year,
      "source": "Website " + medium,
      "medium": "Call Back Form",
      "field_lead_priority": 'Gold',
      "field_page_location": this.sessionStorage.getItem('utmLink') ? this.dom.URL + '?' + this.sessionStorage.getItem('utmLink') : this.dom.URL
    }

    this.dashboardService.addLeadSquared(reqObj).subscribe(res => {
      if (res.message == "Mobile number already exists." || res.status == 'Successfully updated') {
        let reqData = {
          "secret_key": "bd0f12c20c7949caa22d5635f44c1732",
          "college_id": "5802",
          "user_id": res.data.user_id,
          "name": this.callBackForm.value.name,
          "field_last_name": '',
          "country_dial_code": "+91",
          "mobile": this.callBackForm.value.phone,
          "email": this.callBackForm.value.email,
          "field_gender": '',
          "field_exam_category": "",
          "field_exam": this.callBackForm.value.course,
          "field_course_year": '',
          "source": "Website " + medium,
          "medium": "Call Back Form",
          "field_lead_priority": 'Gold',
          "field_reinquire": 'Yes',
          "field_page_location": this.sessionStorage.getItem('utmLink') ? this.dom.URL + '?' + this.sessionStorage.getItem('utmLink') : this.dom.URL

        }
        this.dashboardService.updateLeadSquared(reqData).subscribe((res: any) => {
          if (res) {
            this.callBackForm.reset()
          }
        })
      } else {
        this.callBackForm.reset()
      }
    })
  }

  courseEnquiry() {
    if (this.callBackForm.valid) {
      this.submittedBtn = true;
      let reqObj = {
        name: this.callBackForm.value.name,
        email: this.callBackForm.value.email,
        phone_no: this.callBackForm.value.phone,
        course_name: this.callBackForm.value.course,
        year: this.callBackForm.value.year,
        page_location: this.sessionStorage.getItem('utmLink') ? this.dom.URL + '?' + this.sessionStorage.getItem('utmLink') : this.dom.URL
      }
      this.coursesService.callback(reqObj).subscribe(res => {
        if (res.success) {
          this.getExamCategory1()
          this.addNPF()
          $('#ChooseEquiry').modal('hide')
          this.sendEventToGTM()
         $('#ThanksModal').modal('show')
        }
      })
    } else {
      this.matSnackBar.open('Please enter valid Details', 'OK', {
        verticalPosition: 'top',
        duration: 3000,
        panelClass: 'snack-error'
      })
    }
  }
  bannerObj:any;
  videoLinkMain:any;
  getBannerVideos(){
    this.coursesService.getBannerVideos().subscribe(res=>{
      if(res.length > 0){
        this.bannerObj = res.filter((x:any) => x.category == "Home" )[0];
       this.videoLinkMain = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/'+this.bannerObj.youtube_url+'?rel=0&autoplay=1&mute=1&controls=1&loop=1&&playlist='+this.bannerObj.youtube_url)
      }
    })
  }

  submit() {

    if (this.counsellingForm.valid) {
      let reqObj = {
        name: this.counsellingForm.value.name,
        email: this.counsellingForm.value.email,
        phone_no: this.counsellingForm.value.mobile,
        course: this.counsellingForm.value.course,
        year: this.counsellingForm.value.year,
        time_slot: this.counsellingForm.value.time,
      }

      this.coursesService.homeEnquiry(reqObj).subscribe(res => {
        if (res.success || res.id) {
          this.selectedCategory.push(this.getExamCategory())
          this.addInternalCRMLead('Book 1 on 1 Counselling from MBA Experts')
          this.sendEventToGTM()
          this.matSnackBar.open('Thanks for reaching us. Our Team will get back to you shortly', 'OK', {
            verticalPosition: 'top',
            duration: 3000,
            panelClass: 'snack-success'
          })
        } else {

        }
      }, err => {
        this.matSnackBar.open(err.error.error, 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      })
    }
    else {
      if (this.counsellingForm.controls['name'].hasError('required')) {
        this.matSnackBar.open('Name is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      } else if (this.counsellingForm.controls['email'].hasError('required')) {
        this.matSnackBar.open('Email is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      } else if (this.counsellingForm.controls['mobile'].hasError('required')) {
        this.matSnackBar.open('Phone Number is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      }
      else if (this.counsellingForm.controls['course'].hasError('required')) {
        this.matSnackBar.open('Course is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      }
      else if (this.counsellingForm.controls['year'].hasError('required')) {
        this.matSnackBar.open('Target Year is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      }
      else if (this.counsellingForm.controls['time'].hasError('required')) {
        this.matSnackBar.open('Time Slot is required', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      } else if (this.counsellingForm.controls['email'].hasError('pattern')) {
        this.matSnackBar.open('Email is not Valid', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      } else if (this.counsellingForm.controls['mobile'].hasError('pattern')) {
        this.matSnackBar.open('Phone Number is not Valid', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      }
    }
  }

  gotosection(val: any) {
    var elemnt: any = document.getElementById(val)
    elemnt.scrollIntoView({ behavior: "smooth" })
    if (val == 'courses') {
      this.activeCourseTab = 'Flagship'
    }
  }
  myTarget:any = 98;
  saveTarget(ev:any){
    console.log(ev)
    this.myTarget = ev;
  }

  download() {
    window.open('https://media.iquanta.in/ui_images/new-home/iquanta-vs-other-coaching.webp', '_blank');
  }

  selectType(ev: any) {
    this.yearFilterMyOc = ev.target.value;
    this.cartArray = []
    this.getCustomCourses()
  }

  getCustomCourses() {
    this.selectedCourses = []
    this.coursesService.getCustomCourses('Home').subscribe(res => {
      if (res.success) {
        this.customCourseObj = res.data.filter((x: any) => x.year == parseInt(this.yearFilterMyOc))[0];
        if (this.customCourseObj) {
          this.customCourseObj.custom_section.forEach((section: any) => {
            section.courses = [];
            this.customCourseObj.custom_section_course.forEach((course: any) => {
              if (course.custom_section_id == section.id) {
                section.courses.push(course)
              }
              if (course.status) {
                if (!this.selectedCourses.includes(course.id)) {
                  this.selectedCourses.push(course.id)
                  this.cartArray.push(course)
                }

              }
            })
          })
        }

        setTimeout(() => {
          this.totalActualPrice = 0;
          this.totalOfferPrice = 0;
          this.cartArray.forEach(course => {
            this.totalActualPrice = this.totalActualPrice + course.actual_price;
            this.totalOfferPrice = this.totalOfferPrice + course.offer_price;
          })
        }, 500)
      }
    })
  }

  selectCourse(courseObj: any) {
    if (this.selectedCourses.includes(courseObj.id)) {
      let index = this.selectedCourses.indexOf(courseObj.id)
      this.selectedCourses.splice(index, 1)
      this.cartArray.splice(index, 1)

    } else {
      this.selectedCourses.push(courseObj.id)
      this.cartArray.push(courseObj)
    }

    setTimeout(() => {
      this.totalActualPrice = 0;
      this.totalOfferPrice = 0;
      this.cartArray.forEach(course => {
        this.totalActualPrice = this.totalActualPrice + course.actual_price;
        this.totalOfferPrice = this.totalOfferPrice + course.offer_price;
      })

      if (this.couponCode) {
        if (this.discountAmount > this.totalOfferPrice) {
          this.removeCoupon()
        }
      }

    }, 500)

  }
  referralAmount: any = 0;
  referralCode: any;
  removeCoupon() {
    this.discountAmount = 0;
    this.couponCode = '';
    // this.sessionStorage.removeItem('couponCode')
    this.referralAmount = 0;
    this.referralCode = '';
    // this.sessionStorage.removeItem('referralCode')
    this.totalOfferPrice = 0;
    this.cartArray.forEach(course => {
      this.totalOfferPrice = this.totalOfferPrice + course.offer_price;
    })
  }

  discountAmount: any = 0;
  couponCode: any;
  selectedMenu: any;
  openMenu(val: any) {
    this.selectedMenu = val;
  }
  notificationList: any[] = [];
  selectedIndicator: any;
  selectedIndicatorIndex: any;


  testimonialsList: any[] = [
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-1.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-02.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-03.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-04.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-05.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-06.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-07.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-08.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-09.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-10.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-11.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-12.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-13.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-14.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-15.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-16.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-17.webp',
    'https://media.iquanta.in/ui_images/new-home/cat-2024-topper-18.webp',
  ]

  goNext() {
    let index: any;
    this.selectedIndicatorIndex = this.notificationList.indexOf(this.selectedIndicator) + 1
    this.selectedIndicator = this.notificationList[this.notificationList.indexOf(this.selectedIndicator) + 1];
  }

  goBack() {
    this.selectedIndicatorIndex = this.notificationList.indexOf(this.selectedIndicator) - 1
    this.selectedIndicator = this.notificationList[this.notificationList.indexOf(this.selectedIndicator) - 1];
  }

  gotoFooter() {
    // if(this.selectedIndicator.link)
    window.open(this.selectedIndicator.link, '_blank')
  }

  applyCoupon() {
    if (this.token && this.totalOfferPrice > 0) {
      const dialog = this.dialog.open(CourseCouponDialog, {
        width: '470px',
        panelClass: 'coupon-modal',
        data: { course: this.customCourseObj.id, totalPrice: this.totalOfferPrice }
      })

      dialog.afterClosed().subscribe(res => {
        if (res) {
          if (res.data == 'Invalid Code or Not available for this course') {
            this.sessionStorage.removeItem('couponCode')
          } else if (res.data == 'referral_code does not exist') {
            this.sessionStorage.removeItem('referralCode')
          } else {
            if (res.data[0].amount) {
              this.referralAmount = res.data[0].amount;
              this.referralCode = this.sessionStorage.getItem('referralCode')
              this.totalOfferPrice = 0;
              this.cartArray.forEach(course => {
                this.totalOfferPrice = this.totalOfferPrice + course.offer_price;
              })
              setTimeout(() => {
                this.totalOfferPrice = this.totalOfferPrice - parseInt(this.referralAmount)
              }, 500)

            } else {
              this.discountAmount = res.data[0].discount_amount;
              this.couponCode = this.sessionStorage.getItem('couponCode');
              this.totalOfferPrice = 0;
              this.cartArray.forEach(course => {
                this.totalOfferPrice = this.totalOfferPrice + course.offer_price;
              })
              setTimeout(() => {
                this.totalOfferPrice = this.totalOfferPrice - parseInt(this.discountAmount)
              }, 500)
            }

          }
        }
      })
    } else if (!this.token) {
      this.login()
    } else if (this.totalOfferPrice == 0) {
      this.matSnackBar.open('Cart Value shouldnt be 0', 'OK', {
        verticalPosition: 'top',
        duration: 3000,
        panelClass: 'snack-error'
      })
    }

  }

  submittedBuynow: boolean = false;


  buyNowCustomCourse() {
    if (!this.submittedBuynow) {
      if (this.token && this.userData.email && this.userData.phone_no && this.userData.first_name) {
        this.submittedBuynow = true;
        if (this.cartArray.length > 0) {
          let courseLt: any[] = [];
          this.cartArray.forEach(cart => {
            courseLt.push(cart.id)
          })
          let reqObj: any;
          if (this.couponCode) {
            reqObj = {
              email: this.userData.email,
              phone: this.userData.phone_no,
              custom_course_id: this.customCourseObj.id,
              coupon_code: this.couponCode,
              custom_course_lt: courseLt
            }
          } else if (this.referralCode) {
            reqObj = {
              email: this.userData.email,
              phone: this.userData.phone_no,
              custom_course_id: this.customCourseObj.id,
              referral_code: this.referralCode,
              custom_course_lt: courseLt
            }
          } else {
            reqObj = {
              email: this.userData.email,
              phone: this.userData.phone_no,
              custom_course_id: this.customCourseObj.id,
              custom_course_lt: courseLt
            }
          }

          this.coursesService.purchaseCustomCourse(reqObj, this.token).subscribe(res => {
            if (res.success) {
              this.sessionStorage.setItem('order_id', res.order_id)
              this.customCourseObj.addOns = courseLt;
              if (this.discountAmount > 0) {
                this.customCourseObj.discount_amount = this.discountAmount;
              }
              if (this.referralAmount > 0) {
                this.customCourseObj.referral_amount = this.referralAmount;

              }
              this.sessionStorage.setItem('customCourseArray', JSON.stringify(this.customCourseObj))
              if (res.redirect_url) {
                let url = res.redirect_url.split('?')

                this.sessionStorage.setItem('queryParams', JSON.stringify(url[url.length - 1]))
                this.router.navigate(['/success'])
              } else {

                window.open(res.data, '_self')
              }
            } else {
              this.submittedBuynow = false;
              this.matSnackBar.open(res.data, 'OK', {
                verticalPosition: 'top',
                duration: 3000,
                panelClass: 'snack-error'
              })
            }
          })
        }
      } else if (!this.token) {
        this.login()
      }
      else if (!this.userData.email || !this.userData.phone_no || this.userData.first_name) {
        this.matSnackBar.open('Please update your Profile to continue', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      }
      else {
        this.login()
      }
    }

  }

  login() {
    const dialogRef = this.dialog.open(LoginModal, {
      width: '750px',
      panelClass: 'login_modal',
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {

      } else if (typeof (result) == 'object') {
        if (this.sessionStorage.getItem('usertoken')) {
          this.token = this.sessionStorage.getItem('usertoken');
          this.getProfile()
        } else {
          this.userData = result;
          this.token = this.sessionStorage.getItem('usertoken');;
          this.sessionStorage.setItem('userData', JSON.stringify(result));
          this.loginService.userProfile(this.userData)

        }
      }
    });
  }

  getProfile() {
    this.dashboardService.getProfile(this.token).subscribe(res => {
      if (res.success) {
        this.userData = res.data[0];
        this.sessionStorage.setItem('userData', JSON.stringify(this.userData));
        this.sessionStorage.setItem('mockData', JSON.stringify(res.mock_login))
        this.loginService.userProfile(this.userData)
      }
    })
  }

  tableData: any[] = []

  playVideoFlag: boolean = false;
  playVideoFlagStory: boolean = false;
  yearFilter: any = '2025';

  coursesArray: any[] = []

  ngAfterViewInit() {
    this.iniSlickJs()
    if(isPlatformBrowser(this.platformId)){
      this.displayModule = true;
    }
      const triggerAPICalls = () => {
           window.removeEventListener('scroll', triggerAPICalls);
        window.removeEventListener('click', triggerAPICalls);
        window.removeEventListener('mousemove', triggerAPICalls);
     this.getHomePageCourses('Flagship', 'homepage')
 
    this.getCustomCourses()
      }

        window.addEventListener('scroll', triggerAPICalls);
      window.addEventListener('click', triggerAPICalls);
      window.addEventListener('mousemove', triggerAPICalls);
  }

  isPlaying: boolean = true;
  flagshipCourses:any[]=[]
  getHomePageCourses(val: any, type: any) {
    this.coursesArray = [];
    this.evenArray = [];
    this.oddArray = []
    this.activeCourseTab = val;
    this.coursesService.getPagewiseCourses(val, type, this.yearFilter).subscribe(res => {
      if (res.success) {
        if (res.data.length > 0) {
          this.coursesArray = res.data[0].course.filter((x: any) => !x.is_rq);
          this.flagshipCourses = this.coursesArray;
          this.coursesArray.forEach((course: any, index: any) => {
            if (0 === index % 2) {
              this.evenArray.push(course)
            } else {
              this.oddArray.push(course)
            }
          })
        }

      }
    })
  }

  iniSlickJs() {
    // const htmlScriptElement3 = document.createElement('script');
    // htmlScriptElement3.src = '../../assets/js/home-swiper.js';
    // htmlScriptElement3.setAttribute('async', '')
    // this.elementRef.nativeElement.appendChild(htmlScriptElement3);
  }


  changeYear(ev: any) {
    if (this.yearFilter == '2025') {
      this.yearFilter = '2026'
    } else {
      this.yearFilter = '2025'
    }
    this.getHomePageCourses(this.activeCourseTab, 'homepage')
  }

  evenArray: any[] = [];

  oddArray: any[] = [];

  gotolink(val: any) {
    window.open(val, '_blank')
  }

  whyIquantaItem: any = '1';

  changeTabItem(val: any) {
    this.whyIquantaItem = val;
  }

}
